module.exports = __webpack_public_path__ + "img/mobile.f10ea450.svg";